export const routes = [
  { path: "/", breadcrumb: "Dashboard" },
  { path: "/home", breadcrumb: "Home" },
  { path: "/my-classes", breadcrumb: "My Classes" },
  { path: "/assigned-classes", breadcrumb: "Assigned Classes" },
  { path: "/create-child", breadcrumb: "Add New Child Account" },
  { path: "/manage-child", breadcrumb: "Manage Children Accounts" },
  { path: "/assigned-classes/tasks", breadcrumb: "Class Tasks" },
  { path: "/assigned-classes/tasks/create-task", breadcrumb: "Create New Task" },
  { path: "/timetable", breadcrumb: "My Timetable" },
  { path: "/enroll", breadcrumb: "Join a Class" },
  { path: "/enroll/confirm-enrollment", breadcrumb: "Confirm Group Classes" },
  { path: "/enroll/confirm-private-enrollment", breadcrumb: "Confirm Private Classes" },
  { path: "/my-profile", breadcrumb: "My Profile" },
  { path: "/subscriptions", breadcrumb: "My Subscriptions" },
  { path: "/earnings", breadcrumb: "My Earnings" },
];